<template>
  <div
    class="c-player-title"
    :class="{ 'c-player-title--embedded' : isEmbedded }"
  >
    <div class="c-player-title__container">
      <component
        :is="isEmbedded ? 'h1' : 'h2'"
        class="u-ellipsis"
      >
        {{ title }}
      </component>
      <span
        v-if="episodeTitle"
        class="c-player-title__subtitle u-ellipsis"
      >{{ episodeTitle }}</span>
      <span
        v-else-if="subtitle"
        class="c-player-title__subtitle u-ellipsis"
      >{{ subtitle }}</span>
    </div>
  </div>
</template>
<script>
  import { state } from '@/shared/components/player/store';
  import { ProductType } from '@/shared/enums';

  export default {
    props: {
      isEmbedded: Boolean,
    },
    computed: {
      title() {
        const product = this.product;
        const currentProgram = state.currentLiveProgram;

        if (product.type === ProductType.LIVE) {
          return currentProgram.title || this.$t('glossary.emptyProgram');
        }

        if (product.type === ProductType.EPISODE) {
          return product.season.serial.title;
        }

        return product.title;
      },
      subtitle() {
        if (this.product.type === ProductType.LIVE) {
          const currentProgram = state.currentLiveProgram;
          if (currentProgram.sinceDate) {
            return `${currentProgram.sinceDate.format('HH:mm')} - ${currentProgram.tillDate.format('HH:mm')}`;
          }
        }
      },
      product() {
        return state.product || {};
      },
      episodeTitle() {
        let title = '';
        const product = this.product;

        if (!(product.season && product.season.number) || !product.episode) {
          return;
        }

        const season = `S${product.season.number}`;
        const episode = `E${product.episode}`;

        if (season) {
          title += season;
        }

        if (episode) {
          title += episode;
        }

        if (this.product.title) {
          title += episode
            ? `: ${this.product.title}`
            : this.product.title;
        }

        return title;
      },
    },
  };
</script>
